import React, { useContext } from "react";
import { Grid, Paper, Typography, Hidden } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import background from "../../../images/graphic-icon/backgroundimage.png";
import Footer from "../homeslide/Footer";
import Docpage from "./docpage";
import { LangContext } from "../../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  root: { height: "100%", width: "100%" },
  getstart: {
    marginTop: "1.5rem",
    padding: "0.5rem 2rem",
    fontSize: "1.25rem",
    fontWeight: 400,
    border: "3px solid #FFFFFF",
    color: "#FFFFFF",
  },
  mainpaper: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
    boxShadow: "unset",
  },
  grid: {
    height: "100%",
  },
  bgimage: {
    backgroundImage: `url(${background})`,
    height: 400,
    width: "auto",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  textonimage: {
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  maintext: {
    fontWeight: 700,
    fontSize: "4rem",
    color: "#FFFFFF",
    letterSpacing: 4,
  },
  secondtext: {
    fontSize: "1.2rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#BFC0BF",
    maxWidth: 860,
  },
  item: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    paddingTop: "1rem",
  },
  itemcenter: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  itemtext: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  appbar: {
    position: "static",
    width: "100%",
    height: "5rem",
  },
}));

const Document = (props) => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  return (
    <div>
      <div className={classes.appbar} />
      <Grid container spacing={0} className={classes.root}>
        <Grid item xs={12} className={classes.grid}>
          <Paper className={classes.mainpaper}>
            <Grid container spacing={0} className={classes.root}>
              <Grid item xs={12}>
                <div className={classes.itemcenter}>
                  <div
                    style={{
                      height: "auto",
                      width: "100%",
                      position: "absolute",
                    }}
                  >
                    <div className={classes.itemtext}>
                      <div
                        data-aos="fade-up"
                        data-aos-anchor-placement="top-center"
                        data-aos-duration="1000"
                      >
                        <Typography className={classes.maintext}>
                          {lang.DOCUMENT.toUpperCase()}
                        </Typography>
                        <Hidden smDown mdDown>
                          <div className={classes.item}>
                            <Typography className={classes.secondtext}>
                              {lang.SubtitlesDocument}
                            </Typography>
                          </div>
                        </Hidden>
                      </div>
                    </div>
                  </div>

                  <img
                    alt="bgimage"
                    src={background}
                    style={{
                      width: "100%",
                      height: "auto",
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Docpage />
      <Footer />
    </div>
  );
};

export default Document;
